// Каталожные маршруты называются «ALA-005 Название» - код для людей шум.
// Пока у маршрута нет отдельного поля code (shared:tasks/route-passport.md), код
// отделяется от названия здесь. Только ведущий код и только если после него
// есть само название.
const CODE_RE = /^([A-Z]{2,5}-\d{2,4})\s+(\S.*)$/;

export const splitRouteCode = (name: string): { code: string | null; title: string } => {
  const m = CODE_RE.exec(name.trim());
  return m ? { code: m[1], title: m[2] } : { code: null, title: name };
};

export const routeTitle = (name: string): string => splitRouteCode(name).title;
